export default "__VITE_ASSET__P0ESC8sO__"